export default __webpack_public_path__ + "static/media/cube-bottom.38c977ec.svg";